import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle, ArrowLeft } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) { toast.error("Passwords don't match"); return; }
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (!token) { toast.error("Missing reset token"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed — request a new link.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center bg-paper">
      <div className="max-w-md mx-auto w-full px-6 py-16">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-bold text-rf-orange hover:underline mb-6"><ArrowLeft size={14} /> Back to sign in</Link>
        <p className="overline mb-3">Set new password</p>
        <h1 className="font-display text-4xl md:text-5xl font-black text-rf-ink mb-3 leading-tight">Pick something memorable.</h1>
        <p className="text-rf-ink-soft mb-8">Minimum 6 characters. After resetting, you'll be signed out of all devices.</p>

        {done ? (
          <div className="card-recipe text-center">
            <CheckCircle size={48} weight="duotone" className="mx-auto text-green-600 mb-3" />
            <h2 className="font-display text-2xl font-black text-rf-ink mb-2">Password updated.</h2>
            <p className="text-rf-ink-soft text-sm">Redirecting to sign in…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="overline">New password</label>
              <input data-testid="reset-pw" required type="password" minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} className="input-rf mt-1" />
            </div>
            <div>
              <label className="overline">Confirm new password</label>
              <input data-testid="reset-confirm" required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-rf mt-1" />
            </div>
            <button data-testid="reset-submit" disabled={busy} className="btn-amber w-full">{busy ? "Resetting…" : "Set new password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
